/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/*@ngInject*/
export default function ProviderDetailsController(userService, providerService) {

    var vm = this;

    vm.$onInit = function () {
        loadProvider();
    };

    function loadProvider() {
        providerService.getProvider(userService.getCurrentUser().providerId).then(
            (provider) => {
                vm.provider = provider;
            }
        );
    }


}



// WEBPACK FOOTER //
// ./src/app/provider/provider-details.controller.js